"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.statistics.title': 'Statystyki samouczków',
    'tutorial.statistics.details': 'Uczestnicy i postępy samouczka',
    'tutorial.statistics.subtitle': 'Wybierz samouczek, aby zobaczyć postępy uczestników.',
    'tutorial.statistics.tutorial': 'Samouczek',
    'tutorial.statistics.category': 'Kategoria',
    'tutorial.statistics.actions': 'Akcje',
    'tutorial.statistics.viewParticipants': 'Zobacz uczestników',
    'tutorial.statistics.search': 'Szukaj',
    'tutorial.statistics.retry': 'Spróbuj ponownie',
    'tutorial.statistics.refresh': 'Odśwież',
    'tutorial.statistics.back': 'Powrót do samouczków',
    'tutorial.statistics.pagination': 'Strony samouczków',
    'tutorial.statistics.previous': 'Poprzednia',
    'tutorial.statistics.next': 'Następna',
    'tutorial.statistics.participants': 'Uczestnicy',
    'tutorial.statistics.participant': 'Uczestnik',
    'tutorial.statistics.identity': 'Typ uczestnika',
    'tutorial.statistics.registered': 'Zarejestrowany użytkownik',
    'tutorial.statistics.guest': 'Gość',
    'tutorial.statistics.currentStep': 'Ostatni zapisany krok',
    'tutorial.statistics.currentSection': 'Ostatnia zapisana sekcja',
    'tutorial.statistics.tasks': 'Ukończone zadania',
    'tutorial.statistics.progress': 'Postęp',
    'tutorial.statistics.progressExplanation': 'Postęp to odsetek zadań samouczka ukończonych przez uczestnika. Zapisana pozycja nie oznacza ukończenia.',
    'tutorial.statistics.notStarted': 'Brak zapisanej pozycji',
    'tutorial.statistics.noTasks': 'Brak zadań',
    'tutorial.statistics.emptyTutorials': 'Nie znaleziono samouczków.',
    'tutorial.statistics.emptyParticipants': 'Ten samouczek nie ma jeszcze uczestników.',
    'tutorial.statistics.loadFailed': 'Nie udało się wczytać statystyk samouczka.',
    'tutorial.statistics.time_data': 'Dane czasowe uczestnika samouczka',
    'tutorial.statistics.viewTimeData': 'Zobacz dane czasowe',
    'tutorial.statistics.time': 'Czas w sekcji',
};
